import { pgTable, serial, text, integer, timestamp, jsonb } from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import { z } from "zod/v4";

export const analysesTable = pgTable("analyses", {
  id: serial("id").primaryKey(),
  tenderId: integer("tender_id").notNull(),
  language: text("language", { enum: ["ar", "en"] }).notNull().default("ar"),
  executiveSummary: text("executive_summary"),
  tenderType: text("tender_type"),
  submissionDeadline: text("submission_deadline"),
  requiredDocuments: jsonb("required_documents").$type<string[]>().notNull().default([]),
  technicalRequirements: jsonb("technical_requirements").$type<string[]>().notNull().default([]),
  financialRequirements: jsonb("financial_requirements").$type<string[]>().notNull().default([]),
  legalRequirements: jsonb("legal_requirements").$type<string[]>().notNull().default([]),
  qualificationRequirements: jsonb("qualification_requirements").$type<string[]>().notNull().default([]),
  risks: jsonb("risks").$type<Array<{ title: string; severity: "low" | "medium" | "high"; description: string }>>().notNull().default([]),
  bidDecision: text("bid_decision", { enum: ["bid", "no_bid", "needs_review"] }),
  bidScore: integer("bid_score"),
  bidReasons: jsonb("bid_reasons").$type<string[]>().notNull().default([]),
  missingInformation: jsonb("missing_information").$type<string[]>().notNull().default([]),
  proposalOutline: jsonb("proposal_outline"),
  createdAt: timestamp("created_at").notNull().defaultNow(),
});

export const insertAnalysisSchema = createInsertSchema(analysesTable).omit({ id: true, createdAt: true });
export type InsertAnalysis = z.infer<typeof insertAnalysisSchema>;
export type Analysis = typeof analysesTable.$inferSelect;
